import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { PdBaseUIInput } from "./pd-base-ui-input.js";
import { SharedInputFieldStyles } from "../styles/shared-input-field-styles.js";
import { property } from "lit/decorators.js";
//#region src/base/pd-base-input-element.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
var DELAY_WAIT_TIME_MS = 500;
/**
* Abstract base class for pd-input components (Input, Area, Select).
*
* @event pd-form-element-blur - Fired when input loses focus.
* @event pd-form-element-focus - Fired when input gains focus.
*/
var PdBaseInputElement = class extends PdBaseUIInput {
	constructor(..._args) {
		super(..._args);
		this.placeHolder = "";
		this.name = "";
		this.autoCompleteName = "off";
		this._onInput = (event) => {
			clearTimeout(this._delayTimerId);
			this._delayTimerId = window.setTimeout(() => this._handleChangedValue(this._input.value, event, true, false), DELAY_WAIT_TIME_MS);
		};
	}
	static {
		this.styles = [PdBaseUIInput.styles, SharedInputFieldStyles];
	}
	disconnectedCallback() {
		if (this._delayTimerId) {
			clearTimeout(this._delayTimerId);
			this._delayTimerId = void 0;
		}
		this._input?.removeEventListener("input", this._onInput);
		super.disconnectedCallback();
	}
	firstUpdated() {
		this._input = this.shadowRoot?.querySelector(this._getElementName());
		this._input?.addEventListener("input", this._onInput);
		super.firstUpdated();
	}
	focus() {
		this._input?.focus();
	}
	_onBlur(event) {
		if (this._delayTimerId) {
			clearTimeout(this._delayTimerId);
			this._handleChangedValue(this._input.value, event, true, true);
		}
		this._focused = false;
		this._touched = true;
		this.dispatchEvent(new CustomEvent("pd-form-element-blur", {
			detail: {
				name: this.valueName || this.id || "field",
				value: this._input?.value
			},
			bubbles: true,
			composed: true
		}));
	}
	_onFocus(event) {
		this._focused = true;
		this.dispatchEvent(new CustomEvent("pd-form-element-focus", {
			detail: {
				name: this.valueName || this.id || "field",
				value: this._input?.value
			},
			bubbles: true,
			composed: true
		}));
	}
	_onKeyUp(event) {
		if (event.key === "Enter" && !event.isComposing) {
			clearTimeout(this._delayTimerId);
			this._handleChangedValue(this._input.value, event, true, true);
		}
	}
	_handleStatusForInnerInputElement(status) {
		if (this._inputType === 7 && this._input) {
			this._input.error = !status;
			this._input.valid = status;
		}
	}
	_getElementName() {
		switch (this._inputType) {
			case 5: return "textarea";
			case 2: return "select";
			case 8:
			case 1:
			case 9: return "input";
			case 7: return "pd-input";
			default: return "";
		}
	}
	_getParsedValue() {
		if (this._invalid) return null;
		try {
			if (this._inputType === 1 && this._value) return this.fieldType === "number" ? Number(this._value) : this._value;
		} catch (e) {
			return null;
		}
		return this._value;
	}
};
__decorate([property({ type: String })], PdBaseInputElement.prototype, "placeHolder", void 0);
__decorate([property({ type: String })], PdBaseInputElement.prototype, "name", void 0);
__decorate([property({ type: String })], PdBaseInputElement.prototype, "autoCompleteName", void 0);
//#endregion
export { PdBaseInputElement };
